<template>
    <audio id="myAudio"  autoplay muted loop>
        <source src="https://uchowanca.pl/storage/sounds/christmas-song.mp3" type="audio/mpeg">
        Twoja przeglądarka nie obsługuje elementu audio.
    </audio>
    <div class="d-flex justify-content-center text-center mx-auto">
        <button class="" onclick="document.getElementById('myAudio').muted = false;">Włącz dźwięk</button>
    </div>

    <div class="flex justify-center flex-row" style="background-color: #bf1d24;">
        <img :src="yourImageUrl" class="img-fluid d-block d-md-none" alt="Responsive image">
    </div>


</template>

<script>
export default {
    name: "WishesPage",
    data() {
        return {
            yourImageUrl: 'https://uchowanca.pl/storage/pictures/zyczenia-zarzad-grudzien-2023-80.jpg'
        }
    }
}
</script>

<style scoped>
button {
    border: 1px solid #000000; /* Czarna, cienka ramka */
    padding: 10px 20px; /* Dodatkowa przestrzeń wewnątrz przycisku */
    background-color: white; /* Kolor tła przycisku */
    color: black; /* Kolor tekstu przycisku */
    text-align: center; /* Wyśrodkowanie tekstu */
    text-decoration: none; /* Usunięcie podkreślenia tekstu */
    display: inline-block; /* Styl wyświetlania */
    font-size: 16px; /* Rozmiar czcionki */
    margin: 4px 2px; /* Marginesy wokół przycisku */
    transition-duration: 0.4
}
</style>
